import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useEffect, useState } from "react";
import GlobalMeta from "../reusable/GlobalMeta";
import PageContent from "../layout/PageContent";
import Specialists from "../reusable/fieldGroups/Specialists";
import ContactGroup from "../reusable/fieldGroups/ContactGroup";

export default function Contact(){
     
    const [pageData, setPageData]=useState();

    //Fetch page
    const { isPending, isError, data, error }=useQuery(
        ['about'], //Query key
        ()=>axios({ //Query function
            method:'get',
            url:WP_API_Settings.endpoint+'wp/v2/pages?slug=contact&_embed=true&acf_format=standard'
        })
    );

    useEffect(()=>{
        if(data?.data){
            setPageData(data.data[0]);
        }
    },[data]);

    return(
        <>
            <GlobalMeta/>
            <ContactGroup
                contact={pageData?.acf.contact}
                loading={!pageData}
            />
            <Specialists 
                specialists={pageData?.acf.specialists}
                description={pageData?.acf.specialist_description}
                loading={!pageData}
            />
        </>
    )
}